import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-10-07T11:39:00-0700.
 */
export function useServiceRequestChargeOverrideEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.ServiceRequestChargeOverride,
    false
  );

  return Boolean(isEnabled);
}
